import { CompositeComponent } from 'lib'
import { Box } from 'components/layout/primitives'
import { FlexBox, FlexItem, FlexMods, Overflow } from 'components/styles'
import { composeCssVars, GLOBAl_CSS_VARS, setCssVar } from '../../../lib/css/CssVarProperties'
import { CSS_VARS } from './constants'
import { Mods } from '../../styles/primitives/core/mods'
import { ensureArray } from '../../../lib/types/arrays'
import { ImposterContainer } from '../../layout/primitives/Imposter'

/**
 * Card element - Fiona style card that can accept
 * <Card.Ribbon />, <Card.Body /> and <Card.Footer /> as a composite components
 * @returns
 */
export const Card: CompositeComponent<Mods, 'Header' | 'Body' | 'Footer', Mods> = ({ children, modifiers }) => {
	return (
		<FlexBox
			corners="round"
			elevation={1}
			minWidth="200px"
			direction="column"
			modifiers={[Overflow.Hidden, ImposterContainer, ...ensureArray(modifiers)]}
			space={0}
			style={cardVars}
		>
			{children}
		</FlexBox>
	)
}

const cardVars = composeCssVars(
	setCssVar(CSS_VARS.CARD_SPACE, '1rem'),
	setCssVar(GLOBAl_CSS_VARS.COMPONENT_CONTEXT, 'card')
)

Card.Header = ({ children, modifiers = [FlexMods.Parent({ alignItems: 'center' })] }) => (
	<FlexItem order={1} modifiers={[...ensureArray(modifiers)]}>
		{children}
	</FlexItem>
)
Card.Body = ({ children, modifiers }) => (
	<FlexItem order={2}>
		<Box modifiers={[...ensureArray(modifiers)]}>{children}</Box>
	</FlexItem>
)
Card.Footer = ({ children, modifiers }) => (
	<FlexItem order={3}>
		<Box modifiers={[...ensureArray(modifiers)]}>{children}</Box>
	</FlexItem>
)
